/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SpacedConfirmButton.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import { Box } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import CustomButtonV2 from "../../button/CustomButtonV2";

function SpacedConfirmButton({
  onClickSuccess,
  onClickReject,
  successButtonName,
  rejectButtonName,
}) {
  return (
    <Box
      sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}
    >
      <CustomButtonV2
        type="cancel"
        btnName={rejectButtonName}
        handleOnClick={onClickReject}
      />
      <CustomButtonV2
        type="submit"
        btnName={successButtonName}
        handleOnClick={onClickSuccess}
      />
    </Box>
  );
}

SpacedConfirmButton.propTypes = {
  onClickSuccess: PropTypes.func,
  onClickReject: PropTypes.func,
  successButtonName: PropTypes.node,
  rejectButtonName: PropTypes.node,
};

SpacedConfirmButton.defaultProps = {
  onClickSuccess: () => {},
  onClickReject: () => {},
  successButtonName: "Confirm",
  rejectButtonName: "Cancel",
};

export default SpacedConfirmButton;
